export var gameConfig: any =
{
    tileWidth: 64,
    bgTileWidth: 1024,

    player:
    {
        gravity: 1,
        baseSpeed: 2,
        //baseSpeed: 20,
        boostSpeed: 6,
        //jumpSpeed: -1150,
        jumpSpeed: -1200,
        targetX: 100
    },
    
    level:
    {
        duration: 30,
        platforms:
        {
            //distribution: [3, 5, 8]
            maxPlatforms: 7,
            switchProbability: 0.3,
            patterns:
            [
                [
                    {
                        x: 0,
                        y: 1,
                        length: 2
                    },
                    {
                        x: 5,
                        y: 1,
                        length: 3
                    },
                    {
                        x: 5,
                        y: 2,
                        length: 2
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 4
                    },
                    {
                        x: 4,
                        y: 2,
                        length: 3
                    },
                    {
                        x: 8,
                        y: 1,
                        length: 2
                    },
                    {
                        x: 10,
                        y: 2,
                        length: 1
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 4
                    },
                    {
                        x: 2,
                        y: 2,
                        length: 4
                    },
                    {
                        x: 6,
                        y: 1,
                        length: 2
                    },
                    {
                        x: 8,
                        y: 2,
                        length: 2
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 8
                    },
                    {
                        x: 1,
                        y: 2,
                        length: 1
                    },
                    {
                        x: 5,
                        y: 2,
                        length: 2
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 8
                    },
                    {
                        x: 0,
                        y: 2,
                        length: 3
                    },
                    {
                        x: 8,
                        y: 2,
                        length: 2
                    }
                ],
                [
                    {
                        x: 3,
                        y: 2,
                        length: 8
                    },
                    {
                        x: 0,
                        y: 1,
                        length: 3
                    },
                    {
                        x: 6,
                        y: 1,
                        length: 5
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 2
                    },
                    {
                        x: 9,
                        y: 1,
                        length: 1
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 2
                    },
                    {
                        x: 1,
                        y: 2,
                        length: 1
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 3
                    },
                    {
                        x: 0,
                        y: 2,
                        length: 1
                    },
                    {
                        x: 4,
                        y: 2,
                        length: 2
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 1
                    },
                    {
                        x: 1,
                        y: 2,
                        length: 3
                    }
                ],
                [
                    {
                        x: 0,
                        y: 1,
                        length: 1
                    },
                    {
                        x: 6,
                        y: 1,
                        length: 3
                    }
                ]
            ]
        },
        stages:
        [
            'corridor',
            'gym',
            'science',
            'music'
        ],

        //levelDuration: 10,
        levelDuration: 30,
        lightWidth: 256,
        obstacles:
        {
            gym:
            [
                'tennis-ball',
                'football',
                'basketball'
            ],
            science:
            [
                'science-books-1',
                'science-books-2',
                'science-books-3'
            ],
            corridor:
            [
                'corridor-bag-1',
                'corridor-bag-2',
                'corridor-bag-3'
            ],
            music:
            [
                'music-drum-1',
                'music-drum-2',
                'music-drum-3'
            ]
        }
    },
    powerUps:
        [
            {
                frameName: 'time-up',
                speedModifier: 0,
                scoreModifier: 0,
                timeModifier: 10
            },
            {
                frameName: 'speed-up',
                speedModifier: 1.5,
                scoreModifier: 0,
                timeModifier: 0
            },
            {
                frameName: 'score-up',
                speedModifier: 0,
                scoreModifier: 1500,
                timeModifier: 0
            },
            {
                frameName: 'score-down',
                spedModifier: 0,
                scoreModifier: -5000,
                timeModifier: 0
            },
            {
                frameName: 'speed-down',
                speedModifier: 0.5,
                scoreModifier: 0,
                timeModifier: 0
            },
            {
                frameName: 'time-down',
                spedModifier: 0,
                scoreModifier: 0,
                timeModifier: -5
            }
        ],
    game:
    {
        switchBonus: 1000,
        //startTimeRemaining: 5,
        startTimeRemaining: 60,
        questionBonusTime: 20
    }
};

export var gameState: any =
{
    speed: 3
};




// WEBPACK FOOTER //
// ./src/ts/game/config/GameConfig.ts